
<template>
  <!--门卡信息-->
  <div>
    <div class="advanced-form">
      <div class="card">
        <div class="card-head">
          <h3>
            <span>XX小区1号楼1单元1201室</span>
            <span class="num">
              <span class="tag">正常：</span><span class="normal">2</span>
              <span class="tag">禁用：</span><span class="disabled">4</span>
            </span>
          </h3>
        </div>
        <div class="card-body">
          <x-tabula
            ref="table"
            :columns="columns"
            rowKey="householder_info_id"
            :searchList="searchList"
            :rowOptList="rowOptList"
            :listApi="listApi"
            :searchParams.sync="searchParams"
            :deleteParam="deleteParam"
            :rowSelection="false"
          >
          </x-tabula>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cardInfo',
  data () {
    return {
      roomName: '',
      householderId: '',
      searchList: [
        { props: [''], placeholder: '持卡人手机号、卡号', options: [], inputType: 'input' },
        { props: [''], placeholder: '住户类型', options: [], inputType: 'select' },
        { props: [''], placeholder: '状态', options: [], inputType: 'select' },
        { props: [''], placeholder: ['制卡时间', '制卡时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {},
      rowOptList: [],
      columns: [
        { title: '卡号', dataIndex: '', align: 'left', width: '' },
        { title: '持卡人', dataIndex: '', align: 'left', width: '' },
        { title: '住户类型', dataIndex: '', align: 'left', width: '' },
        { title: '门卡备注', dataIndex: '', align: 'left', width: '' },
        { title: '制卡时间', dataIndex: '', align: 'left', width: '' },
        { title: '状态', dataIndex: '', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      listApi: {
        url: '',
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '',
        param: { pk_key: '', pk_val: '' },
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.roomName = this.$route.query.roomName;
  },
  mounted () {
  },
  methods: {
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
